import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import Modal from "react-modal";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { toast } from 'react-toastify';

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "100%" : '55%',
  },
};

export default function EditDoa({
    editDoaInfo,
    setEdit,
    edit,
}) {
    const mainTopic = "Doa";
    const [doaEditInfo, setDoaEditInfo] = useState({});
    const [categoryList, setCategoryList] = useState([])

    useEffect(() => setDoaEditInfo(editDoaInfo), []);

    useEffect( ()  => {     
      async function fetchData() {   
       const category = await axios.get(`https://ahlehaqserver.herokuapp.com/api/category/${mainTopic}`)
       setCategoryList(category.data.response);
      }
      fetchData(); 
    },[])

    const doaEdit = async (e) => {
        e.preventDefault();
        try {
            const doaInserted = await axios.put(
              `https://ahlehaqserver.herokuapp.com/api/doa/${editDoaInfo._id}`,
              doaEditInfo
            );
    
            //if request success, will show success notification
            if (doaInserted.data.code === 200) {
                
              setEdit(false)
              toast.success("Doa edited successfully!");
              e.target.reset();
            }
        } catch (error) {
          console.log(error);
          toast.error("Internal Server Error!");
        }
      };
    return (
        <>
        <Modal isOpen={edit} style={customStyles}>
         <h1 className="ml-4">Edit a Doa</h1>
         <form onSubmit={doaEdit}>
                      <div className="row">
                         <div className="col-md-6">
                          <div className="form-group">
                              <label for="exampleInputEmail1" className="font-weight-bold">
                                Select category<span className="text-danger">*</span>
                              </label>
                              
                              <select
                                className="form-control rounded"
                                id="exampleInputEmail1"
                                name="category"
                                value={doaEditInfo?.category || ""}
                                required
                                onChange={(e) =>
                                  setDoaEditInfo((prev) => ({
                                    ...prev,
                                    [e.target.name]: e.target.value,
                                  }))
                                }
                              >
                                <option>
                                    "Choose from the list"
                                </option>
                                {categoryList &&
                                  categoryList.map((data) => (
                                    <option value={data.category}>
                                      {data.category}
                                    </option>
                                  ))}
                              </select>  
                          </div>
                        </div>


                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                            Doa Title<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control rounded"
                              placeholder="write doa title"
                              id="exampleInputPassword1"
                              name="title"
                              value={doaEditInfo?.title || ""}
                              required
                              onChange={(e) =>
                                setDoaEditInfo((prev) => ({
                                  ...prev,
                                  [e.target.name]: e.target.value,
                                }))
                              }
                            />
                          </div>
                         </div>

                         <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                              Audio url <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control rounded"
                              id="exampleInputPassword1"
                              name="audioUrl"
                              placeholder="Example: https://example.com"
                              value={doaEditInfo?.audioUrl || ""}
                              required
                              onChange={(e) =>
                                setDoaEditInfo((prev) => ({
                                  ...prev,
                                  [e.target.name]: e.target.value,
                                }))
                              }
                            />
                          </div>
                         </div>
                          
                         <div className="col-md-12">
                            <CKEditor
                                editor={ ClassicEditor }
                                data={doaEditInfo?.description || ""}
                                onChange={ ( event, editor ) => {
                                    const data = editor.getData();
                                    setDoaEditInfo((Prev) => ({ ...Prev, description: data }))
                                   
                                } }
                            />
                         </div>  
                          
                         <div className="col-md-6">
                            <div className="mt-4 ">
                              <button
                                type="submit"
                                className="btn btn-success rounded-pill px-4 ml-auto"
                              >
                                Done
                              </button>
                              <button
                                className="btn btn-danger rounded-pill px-4 ml-3"
                                onClick={() => setEdit(false)}
                                >
                                Close
                                </button>
                            </div>  
                         </div> 

                      </div>

                      
                    </form>
        </Modal>   
        </>
    )
}
